// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__25DwG","content":"styles_content__2wCBX"};